import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { email } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_F07b_SplitPaymentToEmailManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={email}
  />
);

export default Sim_F07b_SplitPaymentToEmailManually;
